﻿import { tabs } from './tabs.js';
import { round, roundDown, roundUp, roundInputToStep } from './util.js';

const init = function (configData) {
    const carData = configData.data.carData;
    const carFilter = configData.data.filter;
    const selectListData = configData.selectListData;

    const priceFilterLease = carFilter.leaseBasic == true
        || carFilter.leaseStandard == true
        || carFilter.leasePlus == true
        || carFilter.leasePriceMonthlyMax != null
        || carFilter.leasePriceMonthlyMin != null
        || carFilter.leasePriceWeeklyMax != null
        || carFilter.leasePriceWeeklyMin != null;

    const resultsSummary = document.getElementById('results-summary');
    //  const resultsCountMakes = resultsSummary.querySelector('[data-result="makes"]');
    //  const resultsCountModels = resultsSummary.querySelector('[data-result="models"]');
    //  const resultsCountVariants = resultsSummary.querySelector('[data-result="variants"]');
    //  const resultsCountCars = resultsSummary.querySelector('[data-result="cars"]');

    const filtersPanelContainer = document.querySelector('[data-panel-filters]'); 
    const filtersPanel = filtersPanelContainer.querySelector('[data-panel]');
    const form = document.getElementById('filters-form');
    const formDetails = form.querySelectorAll('details');
    formDetails.forEach((detail) => {
        detail.addEventListener('toggle', handleDetailsToggle);
    });

    function scrollFilters(el) {
            setTimeout(() => {
                el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
            }, 350);
    }
    function handleDetailsToggle(e) {
        const detail = e.currentTarget;
        if (detail.open) {
            scrollFilters(detail);
        } 

    }


    //  resultsCountMakes.textContent = resultsCount.makes;
    //  resultsCountModels.textContent = resultsCount.models;
    //  resultsCountVariants.textContent = resultsCount.variants;
    //  resultsCountCars.textContent = resultsCount.cars;

    const makeSelect = document.getElementById('Make');
    const modelSelect = document.getElementById('Model');
    const variantSelect = document.getElementById('Variant');
    const table = document.getElementById('table');

    const priceInput = {
        sale: {
            min: form.elements.PriceMin,
            max: form.elements.PriceMax
        },
        finance: {
            min: form.elements.PriceFinanceMin,
            max: form.elements.PriceFinanceMax
        },
        month: {
            min: form.elements.LeasePriceMonthlyMin,
            max: form.elements.LeasePriceMonthlyMax
        },
        week: {
            min: form.elements.LeasePriceWeeklyMin,
            max: form.elements.LeasePriceWeeklyMax
        }
    }
    const mileageInput = {
        min: form.elements.MilesPaMin,
        max: form.elements.MilesPaMax
    }
    const priceDisplayType = () => {
        if (priceInput.sale.min.value != '' || priceInput.sale.max.value != '') {
            return 'sale';
        } else if (priceInput.finance.min.value != '' || priceInput.finance.max.value != '') {
            return 'finance';
        } else if (priceInput.month.min.value != '' || priceInput.month.max.value != '') {
            return 'monthly';
        } else if (priceInput.week.min.value != '' || priceInput.week.max.value != '' || leaseProductInput.leasePlus.checked) {
            return 'weekly';
        } else {
            return 'none';
        }
    };
    const conditionInputs = document.querySelectorAll('[name="condition]');
    conditionInputs.forEach((input) => {
        input.addEventListener('change', handleConditionChange);
    })

    const handleConditionChange = function (e) {

    }
    const conditionType = () => { document.querySelector('[name="condition]:checked').value; };
    const leaseProductInput = {
        basic: form.elements.leaseBasic,
        standard: form.elements.leaseStandard,
        leasePlus: form.elements.leasePlus
    }
    const leaseProductInputHandler = {
        basic: (e) => { },
        standard: (e) => { },
        leasePlus: function (e) {
            if (leaseProductInput.leasePlus.checked) {
                updatePriceDisplayField('weekly');
                updatePriceInputValues('weekly');
                return;
            }
            updatePriceDisplayField(priceDisplayType());
        }
    }
    const priceInputs = form.querySelectorAll('[data-price]');
    const validForPriceTypeInputs = [mileageInput.min, mileageInput.max];

    function setMinMax(input) {
        console.log(`setMinMax()                            ${input.id} ${input.value}`);
        const inputVal = input.valueAsNumber;
        const step = Number(input.step);
        const inputMinId = input.dataset.inputMin;
        const inputMaxId = input.dataset.inputMax;
        if (!isNaN(inputVal) && !isNaN(step)) {
            const roundedVal = round(inputVal, step);
            const val = Number(roundedVal);
            if (inputMinId) {
                const inputMin = document.getElementById(inputMinId);
                if (!inputMin) return;
                //const inputMinVal = inputMin.value;
                const inputMinVal = inputMin.valueAsNumber;
                const minAttrVal = input.dataset.min || input.min || 0;
                const min = Number(minAttrVal);
                const hasMin = !isNaN(min);
                //const hasMinVal = !isNaN(inputMinVal);
                const valLessThanMinAttr = hasMin ? inputVal < min : true;
                //const valLessThanOrEqualToMinVal = hasMinVal ? inputVal <= inputMinVal : false;

                if (valLessThanMinAttr) {
                    input.value = '';
                }
                //else if (valLessThanOrEqualToMinVal) {
                //    input.value = inputMinVal + step;
                //}
                //  else if (!isNaN(inputMinVal)) {
                //          const newVal = val - step;
                //          inputMin.value = inputMinVal > 0 && inputMinVal >= val
                //              ? newVal > 0 ? newVal : ''
                //              : inputMinVal;
                //  }
            } else if (inputMaxId) {
                const inputMax = document.getElementById(inputMaxId);
                if (inputMax) inputMax.setAttribute('data-min', inputVal + step);
                if (inputMax && inputMax.value != '') {
                    const inputMaxVal = inputMax.valueAsNumber;
                    if (!isNaN(inputMaxVal)) {
                        const newVal = val + step;
                        inputMax.value = inputMaxVal > 0 && inputMaxVal <= val
                            ? newVal > 0 ? newVal : ''
                            : inputMaxVal;
                    }
                }
            }
        }
    }
    const emptyWhenZero = function (input) {
        console.log(`emptyWhenZero()                        ${input.id} ${input.value}`);

        const prevVal = input.dataset.val;
        const prev = Number(prevVal);
        const hasPrev = !isNaN(prev);

        const val = input.valueAsNumber
        const hasVal = !isNaN(val);

        const minVal = input.dataset.min || input.min || 0;
        const min = Number(minVal);
        const hasMin = !isNaN(min);

        const prevGreaterThanMin = hasPrev && hasMin && prev > min;
        const prevEqualToMin = hasPrev && hasMin && prev == min;
        const prevLessThanMin = hasPrev && hasMin && prev < min;

        let result = input.value;

        if (hasMin && (!hasPrev || prevLessThanMin) && val > prev) {
            result = min;
        }
        else if (hasMin && hasVal && prevGreaterThanMin) {
            result = val < min || val == 0 ? '' : input.value;
        } else if (val < min) {
            //input.value = val < min || val == 0 ? '' : input.value;
            result = '';
        }
        return result;

        //  const inputValue = input.value;
        //  const val = input.dataset.val;
        //  const valMin = input.dataset.min || input.step;
        //  
        //  const inputValNumber = input.valueAsNumber;
        //  const valNumber = Number(val);
        //  const valMinNumber = Number(valMin);
        //  
        //  //const hasVal = val != undefined && valNumber > 0;
        //  const hasVal = !isNan(valNumber);
        //  const isMin = inputValNumber == valMinNumber;
        //  
        //  const inputMin = input.min;
        //  
        //  const lessThanMin = inputValNumber > 0 && inputValNumber < valMinNumber;
        //  const moreThanMin = inputValNumber > 0 && inputValNumber > valMinNumber;
        //  
        //  
        //  if (hasVal) {
        //      input.value = (inputValNumber == 0 || lessThanMin) ? '' : inputValue;
        //  }
        //  else {
        //      input.value = (isMin || moreThanMin) ? inputValue
        //          : (lessThanMin) ? valMin
        //              : '';
        //  }
        

    }

    const priceChangeHandler = function (e) {
        console.log('change()');
        //console.log(e.type);
        e.preventDefault();
        const input = e.currentTarget;
        //setMinMax(input);
        //const inputValue = input.value;
        //input.value = (inputValue == 0) ? '' : inputValue;
        const priceType = input.dataset.price;


        input.value = emptyWhenZero(input);
        const val = roundInputToStep(input);
        input.dataset.val = val;
        setMinMax(input);

        updatePriceInputValues(priceType);
        updatePriceDisplayField(priceDisplayType());
    }
    const priceInputHandler = function (e) {
        console.log('-----------------------------------');
        console.log('input()');
        //console.log(e.type);
        const input = e.currentTarget;
        const priceType = input.dataset.price;
        //setMinMax(input);
        //updatePriceInputValues(priceType);
        //updatePriceDisplayField(priceDisplayType());
    }
    const validForPriceTypeInputHandler = function (e) {
        const input = e.currentTarget;
        const validTypesVal = input.dataset.validPrices;
        const validTypesArr = validTypesVal.split(':');

        const currentTypeVal = form.elements.PriceDisplay.value;
        const hasCurrentType = validTypesArr.includes(currentTypeVal);

        if (!hasCurrentType) {
            updatePriceInputValues(validTypesArr[0]);
        }
    }

    const mileageMinChangeHandler = function (e) {
        console.log('change()');
        //console.log(e.type);
        e.preventDefault();
        const input = e.currentTarget;
        //console.log('mileageMinChangeHandler:' + ` ${input.id} ${input.value}`);

        //emptyWhenZero(input);
        //roundInputToStep(input);
        input.value = emptyWhenZero(input);
        const val = roundInputToStep(input);
        input.dataset.val = val;
        setMinMax(input);
    }
    const mileageMaxChangeHandler = function (e) {
        console.log('change()');
        //console.log(e.type);
        e.preventDefault();
        const input = e.currentTarget;
        //console.log('mileageMaxChangeHandler:' + ` ${input.id} ${input.value}`);

        //emptyWhenZero(input);
        //roundInputToStep(input);
        input.value = emptyWhenZero(input);
        const val = roundInputToStep(input);
        input.dataset.val = val;
        setMinMax(input);
    }
    const mileageInputHandler = function (e) {
        console.log('-----------------------------------');
        console.log('input()');
        const input = e.currentTarget;
        //console.log('mileageInputHandler:' + ` ${input.id} ${input.value}`);
        //emptyWhenZero(input);
        //setMinMax(input);
    }
    const inputBlurHandler = function (e) {
        console.log('blur()');
        const input = e.currentTarget;
        //setMinMax(input);
    }

    priceInputs.forEach((input) => {
        input.addEventListener('input', priceInputHandler);
        input.addEventListener('change', priceChangeHandler);
        input.addEventListener('blur', inputBlurHandler);
    });
    //priceInputs.forEach((input) => {
    //});
    validForPriceTypeInputs.forEach((input) => {
        input.addEventListener('input', validForPriceTypeInputHandler);
    });
    mileageInput.min.addEventListener("change", mileageMinChangeHandler);
    mileageInput.max.addEventListener("change", mileageMaxChangeHandler);
    mileageInput.min.addEventListener("input", mileageInputHandler);
    mileageInput.max.addEventListener("input", mileageInputHandler);
    mileageInput.min.addEventListener("blur", inputBlurHandler);
    mileageInput.max.addEventListener("blur", inputBlurHandler);


    /*const inStockCheck = document.getElementById('InStock');*/
    const pdiDealCheck = document.getElementById('PdiDeals');

    form.addEventListener('formdata', function (event) {
        let formData = event.formData;
        for (let [name, value] of Array.from(formData.entries())) {
            if (value === '') formData.delete(name);
        }
    });
    form.addEventListener('submit', async (e) => {

        return;
        //e.preventDefault();

        const formData = new FormData(form);

        const inputs = form.elements;

        if (!formData.has('Model')) {
            formData.append('Model', form.elements.Model.options[form.elements.Model.selectedIndex].value)
        }
        if (!formData.has('Variant')) {
            formData.append('Variant', form.elements.Variant.options[form.elements.Variant.selectedIndex].value)
        }

        const jsonData = {};
        for (const pair of formData.entries()) {
            const key = pair[0];
            let val = pair[1];
            const input = form.elements[key];
            if (val == '') {
                val = null;
            } else if (form.elements[key].type == "number" || key=='Make') {
                val = JSON.rawJSON(val);
            }
            //if (val != '' || (input.type == 'checkbox' && input.checked)) {
                jsonData[key] = val;
            //}
        }
        
        for (const input of inputs) {
            // Disable all form controls
            if (input.type == 'checkbox') {
                jsonData[input.name] = input.checked;
            }
        }
        const headers = { 'Content-Type': 'application/json' };
        if (form.elements.__RequestVerificationToken != undefined) {
            headers["RequestVerificationToken"] = form.elements.__RequestVerificationToken.value
        }

        var params = new URLSearchParams(formData);

        const request = new Request("/api/cars-filter", {
            method: "POST",
            body: JSON.stringify(jsonData),
            //body: new URLSearchParams(formData),
            headers: headers
        });

        const response = await fetch(request);
        const jsonResponse = await response.json();
        console.log(jsonResponse);
    })
    makeSelect.addEventListener('change', () => {
        updateModelList();
    });
    modelSelect.addEventListener('change', () => {
        updateVariantList()
    });
    //variantSelect.addEventListener('change', filterRows);


    /*inStockCheck.addEventListener('change', filterRows);*/
    //pdiDealCheck.addEventListener('change', filterRows);

    function initModelList() {
        const opts = modelSelect.querySelectorAll('option[value]');
        modelSelect.disabled = opts.length == 1;
    }
    function updateModelList() {
        const selectedMake = makeSelect.value;
        modelSelect.innerHTML = '<option value="">All Models</option>';
        variantSelect.innerHTML = '<option value="">All Variants</option>';
        variantSelect.disabled = true;
        if (selectedMake) {
            const models = selectListData.models.filter(m => m.make.id == selectedMake);
            models.forEach(model => {
                const option = document.createElement('option');
                option.value = model.id;
                option.textContent = model.name;
                modelSelect.appendChild(option);
            });
            modelSelect.disabled = false;
        } else {
            modelSelect.disabled = true;
            variantSelect.disabled = true;
        }
        //filterRows();
    }
    function updateVariantList() {
        const selectedMake = makeSelect.value;
        const selectedModel = modelSelect.value;
        variantSelect.innerHTML = '<option value="">All Variants</option>';
        if (selectedModel) {
            const variants = selectListData.variants.filter(v => v.model.id == selectedModel && v.make.id == selectedMake);
            variants.forEach(variant => {
                const option = document.createElement('option');
                option.value = variant.id;
                option.textContent = variant.name;
                variantSelect.appendChild(option);
            });
            variantSelect.disabled = false;
        } else {
            variantSelect.disabled = true;
        }
        //filterRows();
    }
    function updatePriceInputValues(priceType) {
        console.log(`updatePriceInputValues()               ${priceType}`);
        priceInputs.forEach((input) => {
            if (input.dataset.price != priceType) {
                input.value = '';
            }
        });

        validForPriceTypeInputs.forEach((input) => {
            const validTypesVal = input.dataset.validPrices;
            const validTypesArr = validTypesVal.split(':');
            const hasValidType = validTypesArr.includes(priceType);
            if (!hasValidType) {
                input.value = '';
            }
        })
    }
    function updatePriceDisplayField(val) {
        console.log(`updatePriceDisplayField()              ${val}`);
        val = val == 'finance' ? 'sale' : val;
        form.elements.PriceDisplay.value = val;

        if (val != 'weekly') {
            leaseProductInput.leasePlus.checked = false;
        }
    }
    leaseProductInput.leasePlus.addEventListener('change', leaseProductInputHandler.leasePlus);
    //leaseProductInput.leasePlus.addEventListener('change', function (e) {
    //    if (leaseProductInput.leasePlus.checked) {
    //        updatePriceDisplayField('weekly');
    //        updatePriceInputValues('weekly');
    //        return;
    //    }
    //    updatePriceDisplayField(priceDisplayType());
    //})


    //filterRows();


    const tabsElem = document.getElementById('filters-form');
    const tabSelected = function (tabs, selectedTab, targetPanelId) {
        tabs.tabPanels.forEach((el) => {
            if (el.classList.contains('inactive')) {
                el.querySelectorAll('details').forEach((d) => { d.open = false; });
            }
        });

        //updatePriceDisplayField(selectedTab.dataset.priceDisplay);
        if (selectedTab.dataset.priceDisplay == "sale") {
            priceInput.month.min.value = '';
            priceInput.month.max.value = '';
            priceInput.week.min.value = '';
            priceInput.week.max.value = '';
        }
        else if (selectedTab.dataset.priceDisplay == "monthly") {
            priceInput.sale.min.value = '';
            priceInput.sale.max.value = '';
            priceInput.finance.min.value = '';
            priceInput.finance.max.value = '';
        }
        updatePriceDisplayField(priceDisplayType());

        const targetPanelEnd = document.getElementById(targetPanelId).lastElementChild;
        scrollFilters(targetPanelEnd);
    }
    const tabsInstance = tabs(tabsElem, {
        tabSelector: '[role="tab"]',
        tabpanelSelector: '.pricing-tab-panel',
        callback: tabSelected
    });

    if (priceFilterLease) {
        //tabsInstance.elem.querySelector('#tab-pricing-lease').click();
    }

    initModelList();
    updateVariantList();

    const numInputs = document.querySelectorAll('.number-step');
    numInputs.forEach((inputGroup) => {
        const input = inputGroup.querySelector('.number-step-input');
        const btnUp = inputGroup.querySelector('.step-button-up');
        const btnDown = inputGroup.querySelector('.step-button-down');
        const minVal = () => input.dataset.min || input.min;
        const min = () => Number(minVal());
        const hasMin = () => !isNaN(min());

        btnUp.addEventListener('click', (e) => {
            console.log('===================================');
            console.log('clickUp()');
            const val = input.valueAsNumber;
            if (hasMin() && (input.value == '' || val < min())) {
                input.value = minVal();
            } else {
                input.stepUp();
            }
            //input.stepUp();
            input.dispatchEvent(new Event('change'));
            //setMinMax(input);
        });
        btnDown.addEventListener('click', (e) => {
            console.log('===================================');
            console.log('clickDown()');
            input.stepDown();
            const val = input.valueAsNumber;
            if (hasMin() && val < min()) {
                input.value = '';
            }

            input.dispatchEvent(new Event('change'));
            //setMinMax(input);
        });
    });
}
export { init };